import * as React from "react";
import type { SVGProps } from "react";

interface TimeoutProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Timeout = ({ cancelled = false, ...props }: TimeoutProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.65 1)">
        <ellipse cx={9.75} cy={12.925} fill="#FFF" rx={8.087} ry={8.143} />
        <path
          fill="#000"
          fillRule="nonzero"
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="M10.986-.375a1.323 1.323 0 0 1 1.316 1.17c.007.472-.133.823-.348 1.072a1.26 1.26 0 0 1-.968.442l-.38.52a9.88 9.88 0 0 1 6.141 3.083 9.73 9.73 0 0 1 2.628 6.66 9.74 9.74 0 0 1-2.893 6.933 9.88 9.88 0 0 1-6.982 2.87 9.88 9.88 0 0 1-6.982-2.87A9.74 9.74 0 0 1-.375 12.57c0-2.57.997-4.91 2.628-6.659a9.88 9.88 0 0 1 6.141-3.083v-.52c-.746 0-1.077-.148-1.317-.388A1.32 1.32 0 0 1 6.69.984c0-.382.147-.717.38-.958.241-.25.575-.401.945-.401zM9.5 4.968a7.67 7.67 0 0 0-5.42 2.228 7.55 7.55 0 0 0-2.243 5.375c0 2.1.857 4 2.243 5.376a7.67 7.67 0 0 0 5.42 2.227 7.67 7.67 0 0 0 5.42-2.227 7.55 7.55 0 0 0 2.243-5.376c0-2.099-.857-4-2.243-5.375A7.67 7.67 0 0 0 9.5 4.968Z"
        />
      </g>
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M12.15 7.361a.75.75 0 0 1 .75.75l-.001 4.139h5.26a.75.75 0 0 1 .744.648l.007.102a.75.75 0 0 1-.75.75h-6.01a.75.75 0 0 1-.75-.75V8.111a.75.75 0 0 1 .75-.75"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Timeout;
